import router from '@/router'
import { uniqBy, uniq } from 'lodash'
import { actions as globalActions } from '@/microAppsConfig'
import { timeout } from '@/utils/util'
import { MAIN_HOME } from '@/config.json'
import { listAgentByUserId } from '@/api/login'

export default {
  state: {
    tabs: [MAIN_HOME],
    activePath: '/main_home',
    lastActivePath: '',
    currentAppKey: '',
    homePath: '/main_home',
    keepAliveRoute: [],
    microApps: {},
    showMicroApp: '',
    removeStatus: '',
    closeSkipPath: '',
    showRobotIcon: false,
    hasAgent: false
  },
  mutations: {
    SET_MICRO_APPS: (state, microApps) => {
      state.microApps = microApps
    },
    SET_MICRO_APP_CHILDREN: (state, { appName, children }) => {
      const { microApps } = state
      const currentApp = microApps[appName]
      if (!currentApp) return
      currentApp.children = uniqBy(children, 'path')
      const childRoutes = {}
      for (const child in microApps) {
        childRoutes[child] = microApps[child].children?.map(item => item.name)
      }
      globalActions.setGlobalState({ microAppRoutes: childRoutes, microAppMap: childRoutes })
    },
    SET_SHOW_MICRO_APP: (state, showMicroApp) => {
      state.showMicroApp = showMicroApp
      const { microApps } = state
      console.log('SET_SHOW_MICRO_APP', microApps, showMicroApp)
      state.homePath = microApps?.[showMicroApp]?.config?.path || MAIN_HOME.path
    },
    setTabs(state, list) {
      state.tabs = list
    },
    // 添加tab
    ADD_TAB: (state, tab) => {
      const { tabs } = state
      const hasIndex = tabs.findIndex(item => item.path === tab.path)
      console.log(51, 'ADD_TAB', tab, hasIndex, tabs)
      if (hasIndex < 0) {
        state.tabs = [...state.tabs, tab]
        return
      }
      tabs[hasIndex] = tab
      state.tabs = [...tabs]
      // state.tabs = uniqBy([...state.tabs, tab], 'path')
    },
    // 添加tab
    UPDATE_TAB: (state, tab) => {
      console.log('UPDATE_TAB', tab)
      const sameIndex = state.tabs.findIndex(t => t.path === tab.path)
      let activeIndex = state.tabs.findIndex(tab => tab.path === state.activePath)
      if (sameIndex > -1 && sameIndex !== activeIndex) {
        state.tabs.splice(sameIndex, 1)
      }
      activeIndex = state.tabs.findIndex(tab => tab.path === state.activePath)
      if (activeIndex > -1) {
        state.tabs.splice(activeIndex, 1, tab)
      } else if (activeIndex === -1) { // 由于go(-1)时导致activePath先变化了，所以可能匹配不到
        if (state.lastActivePath === MAIN_HOME.path) {
          state.tabs.push(tab)
          return
        }
        const lastActiceIndex = state.tabs.findIndex(tab => tab.path === state.lastActivePath)
        state.tabs.splice(lastActiceIndex, 1, tab)
      }
    },
    // 设置激活标签
    SET_ACTIVE_PATH: (state, activePath) => {
      state.lastActivePath = state.activePath
      state.activePath = activePath
    },
    // 设置当前首页
    SET_HOME_PATH: (state, homePath) => {
      const homePathArr = homePath.split('/')
      const ucsIndex = homePath.split('/').indexOf('ucs')
      if (ucsIndex === 0 || ucsIndex === 1) {
        homePath = `${homePathArr.slice(ucsIndex + 1).join('/')}`
      }
      state.homePath = homePath
    },
    // 重置标签数据
    INIT_TABS: state => {
      state.tabs = [MAIN_HOME]
    },
    setShowRoobtIcon: (state, flag = false) => {
      state.showRobotIcon = flag
    },
    sethasAgent: (state, flag = false) => {
      state.hasAgent = flag
    }
  },
  actions: {
    // 移除tab
    async removeTab({ state, commit, dispatch }, tab) {
      console.log(106, tab)
      const { activePath, tabs, microApps, homePath } = state
      const { path, appName, originPath, meta, closed, stopNext } = tab
      const currentApp = microApps[appName]
      let { children } = currentApp || {}
      const { app } = currentApp || {}
      const index = tabs.findIndex(item => item.path === path)

      // 调用子应用的关闭方法
      const { close, isChange } = meta || {}
      // 标准做法
      if (typeof close === 'function') {
        if (activePath !== tab.path) {
          await router.push({
            path: tab.path,
            query: tab.query
          })
        }
        const res = await close()
        if (!res) return
      }

      // 关闭页面如有修改需要进行关闭确认跳转并提示
      if (typeof close === 'string' && isChange) {
        const currentPath = router?.currentRoute?.path
        if (close && currentPath !== path && !closed) {
          if (typeof app?.update !== 'function') return
          if (tab.appName !== tabs.find(itemTab => itemTab.path === state.activePath)?.appName) {
            await timeout(0)
            await router.push({
              path: tab.path,
              query: tab.query
            })
          } else {
            await app.update({ to: tab })
          }
          console.log(app.getStatus())
        }
        if (!closed) {
          if (typeof app?.update !== 'function') return
          await app.update({
            subEvent: {
              name: close,
              params: originPath
            }
          }).catch(err => {
            console.log(err)
            app.mountPromise.then(() => {
              app.update()
            })
          })
          return
        } else if (isChange) {
          if (typeof app?.update !== 'function') return
          await app.update({
            clearAlive: path
          })
          console.log(app.getStatus())
          // debugger
        }
      }

      // 移除指定tab
      const next = tabs.filter(item => item.path !== path)
      if (next) {
        commit('setTabs', next)
      } else {
        console.log(172, next, appName, currentApp, homePath)
      }
      children = children?.filter(item => item.path !== originPath)

      if (appName === 'fas') {
        // 资产关闭每页都需要清除缓存
        if (!app) return
        await app.update({
          clearAlive: path
        })
      }
      commit('SET_MICRO_APP_CHILDREN', {
        appName,
        children
      })
      // 兼容关闭检查页面逻辑
      if (state.removeStatus === 'closeOther' && state.tabs.length === 2 && !stopNext) {
        const next = state.tabs[1]
        await router.push({
          path: next.path,
          query: next.query
        })
        state.activePath = next.path
      } else if (state.removeStatus && state.tabs.length > 1 && !stopNext) {
        // 连续关闭页面
        // 如果关闭的刚好是当前页则需要跳转到下一页
        const next = state.tabs[index - 1]
        // next = next()
        await next && router.push({
          path: next.path,
          query: next.query
        })
        state.activePath = next.path
        // 页面跳转后执行关闭
        await dispatch(state.removeStatus)
      } else if (state.removeStatus && state.tabs.length === 1 && !stopNext) {
        // 关闭到最后一页首页无法关闭，清空连续关闭动作
        // 连续关闭页面最后返回首页
        commit('INIT_TABS')
        state.removeStatus = ''
        // const { homePath } = state
        await timeout(0)
        console.log('移除最后一个标签时的homePath', homePath)
        await router.push(homePath)
      } else if (path === activePath && !stopNext) {
        // 跳转到下一页
        const length = state.tabs.length
        // 因为执行到这里正在关闭的标签已经不在state.tabs中了
        let next = (index === 1 && length > 1) ? state.tabs[index] : state.tabs[index - 1]
        console.log(next)
        if (next.path === MAIN_HOME.path) {
          next = {
            path: homePath
          }
        }
        state.activePath = next.path
        await timeout(0)
        // alert(`跳转前的路径, ${next.path}`)
        await next && router.replace({
          path: next.path,
          query: next.query || {}
        })
      }
      return true
    },
    // 关闭其他
    async closeOther({ state, commit, dispatch }) {
      // 存储需要跳过的路由地址
      const closeSkipPath = state.closeSkipPath || state.activePath
      if (!state.closeSkipPath) {
        state.closeSkipPath = state.activePath
      }

      const excludes = uniq([closeSkipPath, MAIN_HOME.path])
      const res = await dispatch('removeTabs', { excludes, originMethod: 'closeOther' })
      if (!res) return

      // 全部关闭完成清空关闭状态跳转到不需要关闭页面
      state.closeSkipPath = ''
      state.removeStatus = ''
      const remainTabs = state.tabs.filter(tab => excludes.includes(tab.path))
      // const next = state.tabs[1] || state.tabs[0]
      commit('setTabs', remainTabs)
      const next = remainTabs[remainTabs.length - 1]
      await timeout(0)
      await router.push({
        path: next.path,
        query: next.query
      })
      // 获得要删除的tabs并倒序
      // const reverseTabs = state.tabs.filter(tab => ![closeSkipPath, state.homePath].includes(tab.path)).reverse()
      // try {
      //   reverseTabs.forEach(tab => {
      //     if (typeof tab.meta.close === 'string' && tab.meta.isChange) {
      //       state.removeStatus = 'closeOther'
      //       const currentApp = state.microApps[tab.appName]
      //       const { app } = currentApp || {}
      //       if (!app) {
      //         dispatch('removeTab', { ...tab, stopNext: true })
      //       } else {
      //         // 需要检查页面跳转页面并提示是否关闭
      //         closeTabCheck(state.activePath, tab, app)
      //         state.activePath = tab.path
      //         throw new Error()
      //       }
      //     } else {
      //       dispatch('removeTab', { ...tab, stopNext: true })
      //     }
      //   })
      //   // 全部关闭完成清空关闭状态跳转到不需要关闭页面
      //   state.closeSkipPath = ''
      //   state.removeStatus = ''
      //   const next = state.tabs[1] || state.tabs[0]
      //   router.push({
      //     path: next.path,
      //     query: next.query
      //   })
      // } catch (err) {
      //   console.log('err', err)
      // }
    },
    // 关闭全部
    async closeAll({ state, commit, dispatch }) {
      // 关闭顺序从右向左
      const { tabs, homePath } = state
      const currentAppName = tabs.find(itemTab => itemTab.path === state.activePath)?.appName
      const res = await dispatch('removeTabs', { excludes: [MAIN_HOME.path], originMethod: 'closeAll', currentAppName })
      if (!res) return
      // 全部关闭完成清空关闭状态跳转到首页
      state.removeStatus = ''
      const homeTab = state.tabs[0]
      const next = {
        path: homePath
      }
      console.log('全部移除时最后跳转的下一个页面路径对象', next)
      commit('setTabs', [homeTab])
      await timeout(0)
      await router.push({
        path: next.path,
        query: next.query
      })
      // const reverseTabs = [...tabs].reverse()
      // try {
      //   reverseTabs.forEach(tab => {
      //     if (tab.path === homePath) return
      //     if (typeof tab.meta.close === 'string' && tab.meta.isChange) {
      //       state.removeStatus = 'closeAll'
      //       const currentApp = state.microApps[tab.appName]
      //       const currentAppName = tabs.find(itemTab => itemTab.path === state.activePath).appName
      //       const { app } = currentApp || {}
      //       if (!app) {
      //         dispatch('removeTab', { ...tab, stopNext: true })
      //       } else {
      //         // 需要检查页面跳转页面并提示是否关闭
      //         closeTabCheck(state.activePath, tab, app, currentAppName)
      //         state.activePath = tab.path
      //         throw new Error()
      //       }
      //     } else {
      //       dispatch('removeTab', { ...tab, stopNext: true })
      //     }
      //   })
      //   // 全部关闭完成清空关闭状态跳转到首页
      //   state.removeStatus = ''
      //   const next = state.tabs[0]
      //   router.push({
      //     path: next.path,
      //     query: next.query
      //   })
      // } catch (err) {
      //   console.log('err', err)
      // }
    },
    async removeTabs ({ state, dispatch }, { excludes = [], originMethod, currentAppName }) {
      let goOn = true
      const { tabs } = state
      const { length } = tabs
      if (length <= excludes.length) return
      for (let i = tabs.length - 1; i >= 0; i--) {
        console.log('当前tab下标', i)
        const lastTab = tabs[i]
        const { close } = lastTab?.meta || {} // 临时做法
        const isStrClose = typeof close === 'string' && (lastTab.appName !== 'fas' || lastTab.meta.isChange) // 临时做法
        if (excludes.includes(lastTab.path)) { continue }
        const res = isStrClose
          ? await dispatch('beforeRemove', { tab: lastTab, originMethod, currentAppName })
          : await dispatch('removeTab', lastTab)
        await timeout(0)
        if (!res) {
          goOn = false
          break
        }
      }
      return goOn
    },
    // 临时做法，兼容资产关闭逻辑
    async beforeRemove ({ state, dispatch }, { tab = {}, originMethod, currentAppName }) {
      if (tab?.meta?.isChange) {
        state.removeStatus = originMethod
        const currentApp = state.microApps[tab.appName]
        const { app } = currentApp || {}
        if (!app) {
          return await dispatch('removeTab', { ...tab, stopNext: true })
        } else {
          // 需要检查页面跳转页面并提示是否关闭
          await closeTabCheck(state.activePath, tab, app, currentAppName)
          state.activePath = tab.path
          // throw new Error()
          return false
        }
      } else {
        return await dispatch('removeTab', { ...tab, stopNext: true })
      }
    },
    setCloseType({ state }, type) {
      // 设置关闭状态
      state.removeStatus = type || ''
      if (!type) {
        state.closeSkipPath = ''
      }
    },
    logoutTabs({ commit }) {
      commit('INIT_TABS')
    },
    // 检查当前用户是否授权了智能体
    getUserAgent({ commit }) {
      listAgentByUserId().then(res => {
        if (res.code === '0' && res.data && res.data.length) {
          commit('sethasAgent', true)
        } else {
          commit('sethasAgent', false)
        }
      })
    }
  }
}
async function closeTabCheck(activePath, tab, app, currentAppName) {
  const updateObj = {
    subEvent: {
      name: tab.meta.close,
      params: tab.originPath
    }
  }
  if (activePath !== tab.path) {
    if (tab.appName !== currentAppName) {
      await timeout(0)
      await router.push({
        path: tab.path,
        query: tab.query
      })
    } else if (tab.appName === 'fas') {
      updateObj.to = tab
    } else {
      await app.update({ to: tab })
    }
  }
  const res = await app.update(updateObj)
  await timeout(0)
  return res
}
